import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=27c977cc&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
import style0 from "./Overview.vue?vue&type=style&index=0&id=27c977cc&prod&scoped=true&lang=css"
import style1 from "highlight.js/styles/github.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c977cc",
  null
  
)

export default component.exports